import { Flex, Button } from "@radix-ui/themes";
import React, { useState, useEffect } from "react";

const NavBar = ({ scrollToPricing, scrollToTop }) => {
  // State to track the screen width
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Update the state based on the window width
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Set the breakpoint at 768px
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Call it initially to set the state

    return () => window.removeEventListener("resize", handleResize); // Clean up on unmount
  }, []);

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        height: "50px",
        width: "100%",
        backgroundColor: "#0F0F0F",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 1000, // ensures the navbar stays on top of other content
      }}
    >
      <div
        style={{
          paddingLeft: "20px",
          paddingTop: "8px",
          cursor: "pointer",
        }}
        onClick={scrollToTop}
      >
        <img
          src="/tellos_p.png"
          alt="tellos logo"
          style={{ width: "40px", height: "40px", borderRadius: "7px" }}
        />
      </div>

      <div style={{ paddingRight: "20px" }}>
        <Flex gap="4" align="center">
          <Button
            size="2"
            variant="ghost"
            style={{ cursor: "pointer", color: "white" }}
            onClick={scrollToTop}
          >
            About
          </Button>

          {/* <Button
            size="2"
            variant="ghost"
            style={{ cursor: "pointer", color: "white" }}
            onClick={scrollToPricing}
          >
            Pricing
          </Button> */}

          <Button
            size="2"
            variant="solid"
            style={{
              cursor: "pointer",
              display: isSmallScreen ? "none" : "inline-block", // Hide on small screens
              backgroundColor: "black",
              color: "#009951",
            }}
            onClick={() => (window.location.href = "https://client.iamtellos.com")}
          >
            Log In
          </Button>
          <Button
            size="2"
            variant="solid"
            color="green"
            style={{ cursor: "pointer", backgroundColor: "#009951" }}
            onClick={() => (window.location.href = "https://client.iamtellos.com")}
          >
            Start learning
          </Button>
        </Flex>
      </div>
    </div>
  );
};

export default NavBar;
